import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MapFilterModal from "../../shared/createForms/MapFilterModal";
import MapComponent from "../../shared/createForms/MapComponent";
import axios from "axios";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box } from "@mui/material";
import FilteredVendorTable from "../../shared/createForms/FilteredVendorTable";
import { RightArrowLink } from "../../shared/assets/icons";
import RadarComponent from "../../shared/utils/RadarAnimation";
import { DialogContent } from "@mui/material";
import GlobalButton from "../../shared/utils/GlobalButton";

const Map = ({ campaignData, setOpenModalToPublishJobClusters }) => {
  const [availableJobs, setAvailableJobs] = useState([]);
  const [availableClusters, setAvailableClusters] = useState([]);
  const [centerPoint, setCenterPoint] = useState(null);

  const [filterModal, setFilterModal] = useState(false);
  const [toogleForTable, SetToogleForTable] = useState(false);
  const [isRadarLoading, setIsRadarLoading] = useState(false);
  const [machinesNeededForFabrication, setMachinesNeededForFabrication] =
    useState([]);
  const [machinesNeededForPrinting, setMachinesNeededForPrinting] = useState(
    [],
  );
  let mappedLocations = [];
  const serverURL = process.env.REACT_APP_URL;
  const [vendors, setVendors] = useState([]);
  const [isLoadingClusters, setIsLoadingClusters] = useState(false);

  const location = useLocation();

  const [filterData, setFilterData] = useState({
    provideStoreFrontSignages: false,
    providePrintedMaterials: false,
    provideVinylInStoreBranding: false,
    typeofStoreFrontSignages: [],
    minValueKms: 0,
    maxValueKms: 10,
    location: [],
    reliability: "",
    creditLimit: null,
    premises: null,
    selectedCity: "",
    selectedState: "",
    manpower: null,
    machinesNeededForFabrication: [],
    checkMachinesForFabrication: true,
    checkMachinesForPrinting: true,
    machinesNeededForPrinting: [],
  });

  React.useEffect(() => {
    if (campaignData?._id) {
      fetchAllJobsBasedOnCampaignId(campaignData._id);
    }
  }, []);
  useEffect(() => {
    if (campaignData?.rfpId?.products) {
      let machinesNeeded = campaignData.rfpId.products
        .flatMap((product) => {
          const match = filterData.location.find(
            (element) => element.productType === product.productType,
          );
          return match ? product.machinesNeededForFabrication : null;
        })
        .filter(Boolean); // remove nulls
      console.log("Nee", machinesNeeded);

      setMachinesNeededForFabrication(machinesNeeded);
    }
    if (campaignData?.rfpId?.products) {
      const machinesNeeded = campaignData.rfpId.products
        .flatMap((product) => {
          const match = filterData.location.find(
            (element) => element.productType === product.productType,
          );
          return match ? product.machinesNeededForPrinting : null;
        })
        .filter(Boolean); // remove nulls

      setMachinesNeededForPrinting(machinesNeeded);
    }
  }, [filterData]);
  React.useEffect(() => {
    if (availableClusters?.length > 0) {
      const mappedLocations = availableClusters.map((cluster) => {
        return {
          name: cluster.clusterTitle,
          location: cluster.centroidCoordinates,
          productType: cluster?.productType,
        };
      });
    }
  }, [availableClusters]);

  // fetch Jobs
  const fetchAllJobsBasedOnCampaignId = async (id) => {
    setIsLoadingClusters(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/jobs/getAllJobs?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        setAvailableJobs(response.data.data);
        fetchAllBatchesBasedOnCampaignId(response.data.data, id);
      }
    } catch (error) {
      console.error("error in while fetching jobs", error);
    }
  };
  // fetch batches
  const fetchAllBatchesBasedOnCampaignId = async (jobs, id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/batchOfJobs/getAllBatchJobs?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        const updatedBatches = await response?.data?.data.map((batch) => ({
          ...batch,
          jobs: [],
        }));
        jobs?.forEach((job) => {
          const batch = updatedBatches.find(
            (batch) => batch._id === job.batchOfJobsForInstallationPartnerId,
          );
          if (batch) {
            batch.jobs.push(job);
          }
        });
        // setAvailableBatches(updatedBatches);
        fetchAllClustersBasedOnCampaignId(updatedBatches, id);
      }
    } catch (error) {
      console.error("error in while fetching jobs", error);
    }
  };
  // fetch clusters
  const fetchAllClustersBasedOnCampaignId = async (batches = [], id) => {
    setIsLoadingClusters(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/vendorClusterBatches/getAllClusterBatches?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        const updatedClusters = await response?.data?.data.map((cluster) => ({
          ...cluster,
          batches: [],
        }));
        setIsLoadingClusters(false);

        // Only populate batches if they're provided
        if (batches.length > 0) {
          batches?.forEach((batch) => {
            const cluster = updatedClusters.find(
              (cluster) => cluster._id === batch.idOfClusterOfBatchesForVendor,
            );
            if (cluster) {
              cluster.batches.push(batch);
            }
          });
        }
        setAvailableClusters(updatedClusters);
      }
    } catch (error) {
      setIsLoadingClusters(false);

      console.error("error in while fetching clusters", error);
    }
  };
  const getVendorList = async (page = 1, limit = 20) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/api/vendors?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {},
        },
      );
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const loactionArray = vendors?.map((ele, index) => {
    return {
      lat: ele.locationCoordinates?.latitude || ele.locationCoordinates?.lat,
      lng: ele.locationCoordinates?.longitude || ele.locationCoordinates?.lng,
      ownerName: ele.ownerName,
      ownerPrimaryContactNo: ele.ownerPrimaryContactNo,
      vendorBussinessName: ele.vendorBusinessName,
      address: ele.address,
      city: ele.city,
      state: ele.state,
      stars: ele.reliability,
      certificates: ele.certifications,
      creditLimit: ele.creditLimit,
      numberOfEmployees: ele.numberOfEmployees,
      productionArea: ele.productionArea,
      products: ele.products,
      id: ele._id,
      pincode: ele.pinCode,
    };
  });

  const handleOpen = () => {
    setFilterModal(true);
  };

  const handleToogle = () => {
    SetToogleForTable((prevState) => !prevState);
  };
  return (
    <>
      <DialogContent className="bg-white">
        <div className="flex justify-between items-center px-5">
          <div className="flex items-center gap-2">
            {!toogleForTable && (
              <div className="flex items-center">
                <div className="w-30 mt-1">
                  <GlobalButton
                    variant="primary"
                    size="medium"
                    leftIcon={<FilterAltOutlinedIcon />}
                    onClick={handleOpen}
                  >
                    {`Filter`}
                  </GlobalButton>
                </div>
              </div>
            )}
            {loactionArray?.length > 0 && (
              <div className="flex items-center">
                <div className="w-48 mt-1">
                  <GlobalButton
                    variant="primary"
                    size="small"
                    rightIcon={
                      <RightArrowLink color="var(--color-white)" size="18" />
                    }
                    onClick={handleToogle}
                  >
                    {toogleForTable ? "View Map" : "View Filter Vendors"}
                  </GlobalButton>
                </div>
              </div>
            )}
          </div>

          <div className="flex items-center">
            {location.pathname !== "/adminportal/map" && (
              <div className="w-30 mt-1">
                <GlobalButton
                  variant="secondary"
                  size="medium"
                  onClick={() => setOpenModalToPublishJobClusters(false)}
                >
                  {`Close`}
                </GlobalButton>
              </div>
            )}
          </div>
        </div>
      </DialogContent>

      {toogleForTable ? (
        <FilteredVendorTable
          vendorList={loactionArray}
          availableClusters={availableClusters}
          getVendorList={getVendorList}
          filterData={filterData}
        />
      ) : (
        <>
          <div className="min-h-[500px] w-full relative">
            <MapComponent locations={loactionArray} centerPoint={centerPoint} />

            {isRadarLoading && (
              <div className="fixed top-[140px] left-15 w-full h-[500px]  flex justify-center items-center  bg-opacity-80 z-50">
                <RadarComponent />
              </div>
            )}
          </div>
        </>
      )}

      {filterModal && (
        <MapFilterModal
          campaignLocations={mappedLocations}
          setCenterPoint={setCenterPoint}
          centerPoint={centerPoint}
          isLoadingClusters={isLoadingClusters}
          availableJobs={availableJobs}
          availableClusters={availableClusters}
          filterModal={filterModal}
          setFilterModal={setFilterModal}
          setVendors={setVendors}
          vendors={vendors}
          // getVendorList={getVendorList}
          setIsRadarLoading={setIsRadarLoading}
          isRadarLoading={isRadarLoading}
          setFilterData={setFilterData}
          filterData={filterData}
          machinesNeededForFabrication={machinesNeededForFabrication}
          machinesNeededForPrinting={machinesNeededForPrinting}
        />
      )}
    </>
  );
};

export default Map;
